import { getGlsBaseUrl } from '@/api/gls/get-gls-base-url';

/**
 * Builds the FGP update-session (game-switch reconciliation) endpoint.
 */
export const getUpdateSessionEndpoint = (): string | null => {
  let base: string;

  try {
    base = getGlsBaseUrl();
  } catch {
    return null;
  }

  if (!base) {
    return null;
  }

  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;

  return `${trimmedBase}/cfg/api/v1/gameSwitch`;
};
